import styled from 'styled-components'
import {Box} from '@mui/material'
import theme from '../../styles/theme'

export const SettingsBox = styled(Box)`
  width: 66%;
  box-sizing: border-box;
  padding: 32px 20px 64px;
  min-height: calc(100vh - 161px);
  margin: 0 auto;

  ${theme.breakpoints.down('md')} {
    width: 100%;
    min-height: calc(100vh - 121px);
  }

  ${theme.breakpoints.down('sm')} {
    padding: 20px 20px 64px;
  }
`
